export default function IncompleteAssessmentDirective() {
  return {
    template: require('./incomplete-assessment.html'),
    scope: {
      assessment: '=',
      rmmReportingSource: '=',
      isNavantaUser: '=',
    },
    controller: 'IncompleteAssessmentController',
    controllerAs: 'incompleteAssessmentVM',
    bindToController: true,
    replace: true,
  };
}
